import { useState, useEffect } from "react";
import InlineErrors from "./InlineErrors";
import InlineDescription from "./InlineDescription";

const InputFile = (props) => {
	const {
		id,
		label,
		name,
		required = false,
		requiredText,
		placeholder,
		accept = "*",
		description,
		handleChange,
		validateInputFile,
		notEmptyMessage,
		maxFileSizeErrorMessage,
		acceptErrorMessage,
		modifier,
		inlineErrors,
		showInlineErrors = true,
		isMobileView,
		maxSize = 2,
	} = props;

	const mainClass = "help-input-file";
	const modifierClass = modifier ? ` ${mainClass}--${modifier}` : "";
	const strAccept = Array.isArray(accept) ? accept?.join(",") : accept;

	const [hasError, setHasError] = useState();

	useEffect(() => {
		if (!!inlineErrors?.[name]) {
			setHasError(true);
		} else {
			setHasError(false);
		}
	}, [inlineErrors, name]);

	if (!name) return null;

	return (
		<div className={`${mainClass}${modifierClass}`}>
			{label && (
				<label
					className={`${mainClass}__label ${
						hasError ? `${mainClass}__label--error` : ""
					}`}
					htmlFor={!hasError ? id : undefined}
					aria-label={
						label &&
						`${label}${required && requiredText ? ` ${requiredText}` : ""}`
					}
				>
					{label && `${label}${required ? "*" : ""}`}
				</label>
			)}
			{description?.modalContent && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			<input
				className={`${mainClass}__input${
					hasError ? ` ${mainClass}__input--error` : ""
				}`}
				id={id}
				type="file"
				name={name}
				placeholder={placeholder}
				accept={strAccept}
				aria-describedby={hasError ? `${id}_error` : undefined}
				onChange={(e) => {
					validateInputFile &&
						validateInputFile(
							name,
							e.target.files[0],
							required,
							notEmptyMessage,
							maxFileSizeErrorMessage,
							accept,
							acceptErrorMessage,
							maxSize,
							setHasError
						);
					handleChange && e.target.files[0] && handleChange(e);
				}}
				onBlur={(e) => {
					validateInputFile &&
						validateInputFile(
							name,
							e.target.files[0],
							required,
							notEmptyMessage,
							maxFileSizeErrorMessage,
							accept,
							acceptErrorMessage,
							maxSize,
							setHasError
						);
				}}
			/>
			{inlineErrors && showInlineErrors && (
				<InlineErrors validate={id} errorMessages={inlineErrors} />
			)}
			{description?.text && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="bottom"
				/>
			)}
		</div>
	);
};

export default InputFile;
